import React from "react";
import {
  Container,
  Row,
  Col,
} from "react-bootstrap";

import Contactform from "../components/Contactform";
import address from "../assets/images/contact/address.jpg";
import email from "../assets/images/contact/email.jpg";

const Contact = () => {
  return (
    <div>
      <div className="inner-banner">
        <Container>
          <Row>
            <Col xs={12} md={12} className="pr-0">
              <div className="contact-banner text-center">
                <h4>Contact Us</h4>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="contact-content">
        <Container>
          <Row>
            <Col xs={12} md={6}>
              <div className="contact-cart">
                  <img src={address} className="img-fluid" lt="Hive Employee Transportation And Cab Services" />
                  <h5 className="mt-10">Our Address</h5>
                  <p>
                   16th Floor, Prestige Sky Tech, Sy. No. 332 (Part) <br />
 High Fields Road Nearby Bell Techlogix  Nanakramguda <br />
Hyderabad , Rangareddy ,Telangana , 500032
                  </p>
                </div>
            </Col>
            <Col xs={12} md={6}>
            <div className="contact-cart">
                <img src={email} className="img-fluid" alt="Hive Employee Transportation And Cab Services" />
                <h5 className="mt-20">Contact Information</h5>
                <p>
                  <b>Phone</b> : +91- 9247009364 <br />
                  <b>Email</b> : info@hivemobility.in <br />
                  
                </p>
              </div>
            </Col>
            
          </Row>
          <Row>
           
            <Col xs={12} md={6}>
             <Contactform />
            </Col>
            <Col xs={12} md={6}>
              <div className="map-cart">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d243647.31698248573!2d78.26795853991645!3d17.4122998009489!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb99daeaebd2c7%3A0xae93b78392bafbc2!2sHyderabad%2C%20Telangana!5e0!3m2!1sen!2sin!4v1633673132504!5m2!1sen!2sin" width="100%" height="350"  allowfullscreen="" loading="lazy"></iframe>
              </div>
            </Col>
          </Row>
          
        </Container>
      </div>
    </div>
  );
};

export default Contact;
